import { connect } from 'react-redux'
import WelcomeComponent from '../../components/welcome'
import { AppState } from '../../store'

interface OwnProps {
}

interface Props {
}

export type MergedProps = OwnProps & Props

const mapStateToProps = (state: AppState, ownProps: OwnProps): {} => {
	return Object.assign({}, ownProps)
}

export default connect(mapStateToProps)(WelcomeComponent)



// WEBPACK FOOTER //
// ./src/containers/welcome/index.ts